module.exports = __webpack_public_path__ + "static/media/20201114_124341_071_IMG_9959.f780fe2f.jpg";